import api from './BaseApi';

// Helper function to convert relative image URLs to absolute
const getAbsoluteImageUrl = (imageUrl) => {
    if (!imageUrl) return null;
    
    // If already absolute URL, return as is
    if (imageUrl.startsWith('http://') || imageUrl.startsWith('https://')) {
        return imageUrl;
    }
    
    // Use the IMAGE base URL from environment variable
    const imgBaseUrl = process.env.REACT_APP_IMG_BASE_URL || 'http://localhost:3001/';
    const baseUrl = imgBaseUrl.endsWith('/') ? imgBaseUrl.slice(0, -1) : imgBaseUrl;
    return `${imgBaseUrl}${imageUrl.startsWith('/') ? '' : '/'}${imageUrl}`;
};

export const processUserData = (user) => {
    if (!user) return user;
    const rawImage = user.image || user.profile_image;
    const absImage = getAbsoluteImageUrl(rawImage);
    return {
        ...user,
        image: absImage,
        profile_image: absImage
    };
};

export const processUsersData = (users) => {
    if (!Array.isArray(users)) return users;
    return users.map(user => processUserData(user));
};

export const createUser = async (data) => {
    try {
        // If data contains a file, use FormData for multipart upload
        if (data instanceof FormData) {
            const response = await api.post('/admin/users', data);
            return response;
        }
        const response = await api.post('/admin/users', data);
        return response; 
    } catch (error) {
        console.error('Create User error:', error);
        throw error;
    }
};

export const getUsers = async (params) => {
    try {
        const response = await api.get('/admin/users', { params });
        // Process user data to convert relative image URLs to absolute
        if (response.data && response.data.data) {
            response.data.data = processUsersData(response.data.data);
        }
        return response.data;
    } catch (error) {
        console.error('Get Users error:', error);
    }
};

export const updateUser = async (id, data) => {
    try {
        // If data contains a file, use FormData for multipart upload
        if (data instanceof FormData) {
            const response = await api.put(`/admin/users/${id}`, data);
            return response;
        }
        const response = await api.put(`/admin/users/${id}`, data);
        return response; 
    } catch (error) {
        console.error('Update User error:', error);
        throw error;
    }
};

export const getSingleUser = async (id) => {
    try {
        const response = await api.get(`/admin/users/${id}`);
        // Process user data to convert relative image URLs to absolute
        if (response.data && response.data.data) {
            response.data.data = processUserData(response.data.data);
        }
        return response.data;
    } catch (error) {
        console.error('Get User error:', error);
    }
};

export const deleteUser = async (id) => {
    try {
        const response = await api.delete(`/admin/users/${id}`);
        return response.data;
    } catch (error) {
        console.error('Delete User error:', error);
    }
};

export const toggleUserStatus = async ({ status, id }) => {
    try {
        const response = await api.patch(`/admin/users/${id}/status`, { status });
        return response; 
    } catch (error) {
        console.error('Toggle User Status error:', error);
        throw error;
    }
};

export const getUserActivities = async (userId, params) => {
    try {
        const response = await api.get(`/admin/users/${userId}/activities`, { params });
        return response.data;
    } catch (error) {
        console.error('Get User Activities error:', error);
        throw error;
    }
};

export const sendUserNotification = async (userId, data) => {
    try {
        const response = await api.post(`/admin/users/${userId}/send-notification`, data);
        return response.data;
    } catch (error) {
        console.error('Send Notification error:', error);
        throw error;
    }
};

export const removeUserImage = async (id) => {
    try {
        const response = await api.delete(`/admin/users/${id}/image`);
        return response.data;
    } catch (error) {
        console.error('Remove user image error:', error);
        throw error;
    }
};

export const forcePasswordResetUser = async (id) => {
    try {
        const response = await api.post(`/admin/users/${id}/force-password-reset`);
        return response.data;
    } catch (error) {
        console.error('Force password reset user error:', error);
        throw error;
    }
};